import React from "react";
import { CreateButton, List } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import {
  CreateMagazineTemplateModal,
  EditMagazineTemplateModal,
  MagazineTemplateListFilters,
} from "@modules/magazineTemplates/components";

import { useMagazineTemplatesList } from "./controller";
import { useMagazineTemplatesListColumns } from "./columns";

export const MagazineTemplatesList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    createMagazineTemplatesModalRef,
    editMagazineTemplatesModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useMagazineTemplatesList();

  const columns = useMagazineTemplatesListColumns(
    refetch,
    translate,
    editMagazineTemplatesModalRef
  );

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <MagazineTemplateListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="magazinetemplates.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton
            onClick={() => createMagazineTemplatesModalRef.current?.open()}
          />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateMagazineTemplateModal
        onComplete={() => {
          refetch();
        }}
        modalRef={createMagazineTemplatesModalRef}
      />
      <EditMagazineTemplateModal
        onComplete={() => {
          refetch();
        }}
        modalRef={editMagazineTemplatesModalRef}
      />
    </List>
  );
});
